export enum NotificationGroupType {
    notes = 1,
    soMe = 2,
    activity = 3,
}
